export let TabsIndicatorCssVars = /*#__PURE__*/function (TabsIndicatorCssVars) {
  /**
   * Indicates the distance on the left side from the parent's container if the tab is active.
   * @type {number}
   */
  TabsIndicatorCssVars["activeTabLeft"] = "--active-tab-left";
  /**
   * Indicates the distance on the right side from the parent's container if the tab is active.
   * @type {number}
   */
  TabsIndicatorCssVars["activeTabRight"] = "--active-tab-right";
  /**
   * Indicates the distance on the top side from the parent's container if the tab is active.
   * @type {number}
   */
  TabsIndicatorCssVars["activeTabTop"] = "--active-tab-top";
  /**
   * Indicates the distance on the bottom side from the parent's container if the tab is active.
   * @type {number}
   */
  TabsIndicatorCssVars["activeTabBottom"] = "--active-tab-bottom";
  /**
   * Indicates the width of the tab if it is active.
   * @type {number}
   */
  TabsIndicatorCssVars["activeTabWidth"] = "--active-tab-width";
  /**
   * Indicates the height of the tab if it is active.
   * @type {number}
   */
  TabsIndicatorCssVars["activeTabHeight"] = "--active-tab-height";
  return TabsIndicatorCssVars;
}({});